<template>
  <div class="intelligentMatching">
    <Form
      :model='form'
      :rules="rules"
      v-model="regular"
    >
      <CompanySelect
        v-model="form.businessname"
        name="企业名称"
        label="企业名称"
        placeholder="请选择企业"
        :getSelect='getSelect'
      />
      <Input
        class="g_temr"
        v-model="form.taxnumber"
        name="企业税号"
        label="企业税号"
        placeholder="请输入企业税号"
        disabled
        readonly='false'
      />
      <Input
        class="g_temr"
        v-model="form.loanname"
        :reg="rules.loanname"
        name="借款人姓名"
        label="借款人姓名"
        placeholder="请输入借款人姓名"
        disabled
        readonly='false'
      />
      <Input
        class="g_temr"
        v-model="form.loankind"
        :reg="rules.loankind"
        name="借款人类型"
        label="借款人类型"
        placeholder="请输入借款人类型"
        disabled
        readonly='false'
      />
    </Form>
    <Button
      :loading="loading"
      loadingText="匹配中..."
      type="danger"
      text="立即匹配"
      :disabled="!regular"
      class="nextStep"
      :click="nextStep"
    />

    <AuthenticationPopup
      title="提示"
      :isClose="false"
      @define="define"
      btnText="去认证"
      v-model="currentPropType.flagAuth"
    ></AuthenticationPopup>

    <BindingEnterprisePopup
      title="提示"
      :isClose="false"
      @define="defineBind"
      btnText="去绑定"
      v-model="currentPropType.flagBind"
    ></BindingEnterprisePopup>

  </div>

</template>

<script>
import Input from '@/components/Input.vue';
import Form from '@/components/Form.vue';
import Button from '@/components/Button.vue';
import publicPageAPI from '@/request/api/publicPage';
import AuthenticationPopup from './components/AuthenticationPopup.vue';
import CompanySelect from './CompanySelect.vue';
import BindingEnterprisePopup from './components/BindingEnterprisePopup.vue';


export default {
  name: 'intelligentMatching',
  components: {
    CompanySelect,
    Input,
    Form,
    Button,
    AuthenticationPopup,
    BindingEnterprisePopup,
  },
  data() {
    return {
      form: {
        businessname: '',
        taxnumber: '',
        loanname: '',
        loankind: '',
      },
      rules: {
        businessname: [{ required: true, message: '请选择企业' }],
        taxnumber: [{ required: true, message: '请选择企业' }],
        loanname: [{ required: true, message: '请选择企业' }],
        loankind: [{ required: true, message: '请选择企业' }],
      },
      isShowAuthen: false,
      loading: false,
      regular: true,
      isShowBind: false,
      flagAuth: false,
      flagBind: false,
      borrowerType: '',
    };
  },

  mounted() {
    this.getUserInfoFc();
  },
  methods: {
    getUserInfoFc() {
      publicPageAPI.getUserInfo().then((res) => {
        console.log('res===', res);
        if (res.success === true) {
          if (res.data.identity === '') {
            this.isShowAuthen = true;
          } else {
            this.form.loanname = res.data.userName;
          }
        }
      });
    },
    nextStep() {
      this.$router.push(`/supermarket/v2/maching?corpName=${this.form.businessname}&taxNo=${this.form.taxnumber}&borrowerName=${this.form.loanname}&borrowerType=${this.borrowerType}`);
    },
    define() {
      // setItem设置缓存，认证方法中getItem获取缓存，
      localStorage.setItem('returnPage', '/supermarket/v2/intelligentMatching');
      this.$router.push('/supermarket/v2/realName');
    },
    defineBind() {
      localStorage.setItem('returnPage', '/supermarket/v2/intelligentMatching');
      this.$router.push('/supermarket/v2/bindingEnterprise');
    },
    getSelect(value) {
      console.log('value===', value);
      if (value) {
        this.form.businessname = value.corpName;
        this.form.taxnumber = value.taxNo;
        this.form.loankind = value.userTypeDesc;
        this.borrowerType = value.userType;
      } else {
        this.isShowBind = true;
      }
    },
  },
  computed: {
    currentPropType() {
      if (this.isShowAuthen === true) {
        return {
          flagAuth: true,
          flagBind: false,
        };
      }
      if (this.isShowBind === true) {
        return {
          flagAuth: false,
          flagBind: true,
        };
      }
      return {
        flagAuth: false,
        flagBind: false,
      };
    },
  },

};

</script>

<style scoped>
.g_temr::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0 16px;
  /* margin-left: 20px; */
  box-sizing: border-box;
  /* padding-left: 20px; */
  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: " ";
  pointer-events: none;
}
</style>
<style>
.g_temr .input_box {
  margin-left: 20px;
}
.nextStep {
  margin-top: 12px;
}
</style>

